import type { KlearFinancialAccount } from '@klear/klear-financial-account/klear-financial-account'
import { Label } from '@klear/ui/components/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@klear/ui/components/select'
import { klearAccountOptionLabel } from '@klear/ui/hooks/use-klear-financial-account'
import toNumber from 'lodash/toNumber'
import toString from 'lodash/toString'

type KlearAccountSelectProps = {
  accounts: KlearFinancialAccount[]
  value: number | null | undefined
  onChange: (accountId: number) => void
  label?: string
  showBalance?: boolean
  className?: string
}

export function KlearAccountSelect({
  accounts,
  value,
  onChange,
  label = 'Klear Account',
  showBalance = true,
  className
}: KlearAccountSelectProps) {
  if (accounts.length <= 1) return null

  const selected = accounts.find((a) => a.id === value) ?? accounts[0]

  return (
    <div className={className ?? 'space-y-2'}>
      <Label>{label}</Label>
      <Select
        value={selected?.id != null ? toString(selected.id) : undefined}
        onValueChange={(next) => onChange(toNumber(next))}
      >
        <SelectTrigger className="w-full" aria-label={label}>
          <SelectValue placeholder="Select Klear account" />
        </SelectTrigger>
        <SelectContent>
          {accounts.map((account) => (
            <SelectItem key={account.id} value={toString(account.id)}>
              {klearAccountOptionLabel(account)}
              {showBalance && account.account ? ` · ${account.balanceAvailable.toString()}` : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
